export default __webpack_public_path__ + "static/media/Snd_Try5.93a49122.mp3";